if(!customElements.get('vp-product-gallery')){
  customElements.define('vp-product-gallery',class extends HTMLElement{
    connectedCallback(){
      if(this.initialized)return;
      this.initialized=true;
      this.slides=[...this.querySelectorAll('[data-media-id]')];
      this.thumbs=[...this.querySelectorAll('[data-index]')];
      this.index=Math.max(0,this.slides.findIndex(e=>!e.hidden));
      this.form=this.closest('form');
      this.variantMedia=JSON.parse(this.querySelector('[data-variant-media]').textContent);
      this.variantId=this.form?.querySelector('[name="id"]')?.value;
      this.controller=new AbortController();
      const options={signal:this.controller.signal};
      this.addEventListener('click',event=>{
        const thumb=event.target.closest('[data-index]');
        const arrow=event.target.closest('[data-direction]');
        if(thumb)this.show(Number(thumb.dataset.index));
        if(arrow)this.show(this.index+Number(arrow.dataset.direction));
      },options);
      const stage=this.querySelector('.vp-gallery-stage');
      stage.addEventListener('keydown',event=>{
        if(event.key==='ArrowRight'||event.key==='ArrowLeft'){
          event.preventDefault();this.show(this.index+(event.key==='ArrowRight'?1:-1));
        }
      },options);
      stage.addEventListener('pointerdown',event=>{this.pointerStart={x:event.clientX,y:event.clientY};},options);
      stage.addEventListener('pointerup',event=>{
        if(!this.pointerStart||event.target.closest('video,iframe,model-viewer'))return;
        const dx=event.clientX-this.pointerStart.x,dy=event.clientY-this.pointerStart.y;
        this.pointerStart=null;
        if(Math.abs(dx)>50&&Math.abs(dx)>Math.abs(dy)*1.5)this.show(this.index+(dx<0?1:-1));
      },options);
      this.syncVariant=()=>{
        const id=this.form?.querySelector('[name="id"]')?.value;
        if(!id||id===this.variantId)return;
        this.variantId=id;
        const index=this.slides.findIndex(e=>e.dataset.mediaId===this.variantMedia[id]);
        if(index>=0)this.show(index);
      };
      this.form?.addEventListener('change',()=>setTimeout(this.syncVariant,100),options);
      this.form?.addEventListener('click',()=>{setTimeout(this.syncVariant,100);setTimeout(this.syncVariant,350);},options);
      this.observer=new MutationObserver(this.syncVariant);
      if(this.form)this.observer.observe(this.form,{subtree:true,attributes:true,attributeFilter:['value','gp-context','gp-data']});
    }
    show(index){
      if(!this.slides.length)return;
      this.index=(index+this.slides.length)%this.slides.length;
      this.slides.forEach((slide,i)=>{
        slide.hidden=i!==this.index;
        if(i!==this.index)slide.querySelectorAll('video').forEach(video=>video.pause());
      });
      this.thumbs.forEach((thumb,i)=>thumb.setAttribute('aria-pressed',String(i===this.index)));
      const thumb=this.thumbs[this.index],strip=this.querySelector('.vp-gallery-thumbnails');
      if(thumb&&strip){
        const left=thumb.offsetLeft-strip.offsetLeft;
        if(left<strip.scrollLeft||left+thumb.offsetWidth>strip.scrollLeft+strip.clientWidth){
          strip.scrollTo({left:Math.max(0,left-strip.clientWidth/2+thumb.offsetWidth/2),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
        }
      }
    }
    disconnectedCallback(){this.controller?.abort();this.observer?.disconnect();this.initialized=false;}
  });
}
